import { device } from '@ui-components/breakpoints';
import {
    iconPlay,
    playTransitionCubicEaseInOut,
    regularBlack,
    regularWhite,
} from '@ui-components/design-tokens';
import PlayImage from '@ui-components/PlayImage';
import SvgIcon, { SvgIcons } from '@ui-components/SvgIcon';
import { StyledIconBackground } from '@ui-components/SvgIcon/SvgIcon.styles';
import { playFontIcon, playFontSize } from '@ui-components/typography/helpers';
import PlayText from '@ui-components/typography/PlayText/PlayText';
import styled, { css } from 'styled-components';
import { ContentItemLink } from '../../ContentItem.styles';

type StyledPlayIconProps = {
    onlyAvailableInSweden: boolean;
};

export const StyledPlayIcon = styled(SvgIcon).attrs({ icon: SvgIcons.PLAY_OPAQUE, width: 50 })`
    position: absolute;
    top: 50%;
    left: calc(50%);
    z-index: 10;
    transform: translate(-50%, -50%);
    width: 40px;
    display: flex;
    opacity: 0;

    @media ${device.GteMedium} {
        left: calc(50%);
        width: 50px;
    }

    .touchevents & {
        top: unset;
        bottom: 5px;
        left: 5px;
        transform: none;
        display: block;
        width: 30px;
        opacity: 1;
    }

    .no-touchevents.no-sweden && {
        ${(props: StyledPlayIconProps) =>
            props.onlyAvailableInSweden &&
            css`
                display: none !important;
            `}
    }

    ${(props: StyledPlayIconProps) =>
        props.onlyAvailableInSweden &&
        css`
            .no-sweden && {
                display: none;
                opacity: 0;
            }
        `}

    /* stylelint-disable */
    ${ContentItemLink}:hover & {
        /* stylelint-enable */

        .no-touchevents & {
            transition: opacity 120ms ${playTransitionCubicEaseInOut};
            opacity: 1;
            color: ${regularBlack};
            width: 100px;
            background-color: ${regularWhite};
            ${playFontSize(1.3)}
            text-transform: uppercase;
            font-weight: 700;
            border-radius: 33px;
            height: 37px;
            display: flex;
            justify-content: left;
            align-items: center;

            ${StyledIconBackground} {
                display: none;
            }

            &:before {
                ${playFontIcon(2.3, iconPlay)}
                margin-left: 10px;
            }

            &:after {
                content: 'Spela';
                margin-left: 4px;
            }
        }
    }
`;

export const StyledContentItemFigure = styled(PlayImage)`
    transition: transform 0.2s ${playTransitionCubicEaseInOut};
    transform-origin: center;
    overflow: hidden;

    /* stylelint-disable */
    ${ContentItemLink}:hover & {
        /* stylelint-enable */
        transform: scale(1.02);
    }
`;

export const OutsideSwedenContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const OutsideSwedenText = styled(PlayText)`
    display: none;
    z-index: 1;
    opacity: 1;
    position: absolute;

    .no-sweden && {
        display: block;
    }
`;
